
/* !!! This is code generated by Prisma. Do not edit directly. !!!
/* eslint-disable */

Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.16.3
 * Query Engine version: bb420e667c1820a8c05a38023385f6cc7ef8e83a
 */
Prisma.prismaVersion = {
  client: "6.16.3",
  engine: "bb420e667c1820a8c05a38023385f6cc7ef8e83a"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.EventScalarFieldEnum = {
  id: 'id',
  name: 'name',
  city: 'city',
  countrySubdivisionNameLevel1: 'countrySubdivisionNameLevel1',
  countrySubdivisionDisplayCodeLevel1: 'countrySubdivisionDisplayCodeLevel1',
  countrySubdivisionNameLevel2: 'countrySubdivisionNameLevel2',
  countrySubdivisionDisplayCodeLevel2: 'countrySubdivisionDisplayCodeLevel2',
  country: 'country',
  longitude: 'longitude',
  latitude: 'latitude',
  peyceReview: 'peyceReview',
  websiteUrl: 'websiteUrl',
  facebookUrl: 'facebookUrl',
  twitterUrl: 'twitterUrl',
  instagramUrl: 'instagramUrl',
  images: 'images',
  coverImage: 'coverImage',
  isFeatured: 'isFeatured',
  airtableId: 'airtableId',
  status: 'status',
  slug: 'slug',
  toUpdate: 'toUpdate',
  algoliaObjectToUpdate: 'algoliaObjectToUpdate',
  algoliaObjectToDelete: 'algoliaObjectToDelete',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  fullAddress: 'fullAddress',
  oldSlugId: 'oldSlugId',
  eventHubspotId: 'eventHubspotId',
  eventSwellId: 'eventSwellId',
  dataSource: 'dataSource',
  isPrivate: 'isPrivate',
  revalidatedAt: 'revalidatedAt',
  isRecommended: 'isRecommended'
};

exports.Prisma.EventLocalizedContentScalarFieldEnum = {
  locale: 'locale',
  review: 'review',
  eventId: 'eventId'
};

exports.Prisma.EditionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  confirmedAt: 'confirmedAt',
  medusaVersion: 'medusaVersion',
  slug: 'slug',
  currency: 'currency',
  startDate: 'startDate',
  endDate: 'endDate',
  year: 'year',
  generalRulesUrl: 'generalRulesUrl',
  hasInsurance: 'hasInsurance',
  clientExternalUrl: 'clientExternalUrl',
  registrantsNumber: 'registrantsNumber',
  registrationOpeningDate: 'registrationOpeningDate',
  registrationClosingDate: 'registrationClosingDate',
  isContacted: 'isContacted',
  bibWithdrawalStreet: 'bibWithdrawalStreet',
  bibWithdrawalPostalCode: 'bibWithdrawalPostalCode',
  bibWithdrawalCity: 'bibWithdrawalCity',
  bibWithdrawalSubdivisionNameLevel2: 'bibWithdrawalSubdivisionNameLevel2',
  bibWithdrawalSubdivisionNameLevel1: 'bibWithdrawalSubdivisionNameLevel1',
  bibWithdrawalCountry: 'bibWithdrawalCountry',
  bibWithdrawalLongitude: 'bibWithdrawalLongitude',
  bibWithdrawalLatitude: 'bibWithdrawalLatitude',
  bibWithdrawalInfo: 'bibWithdrawalInfo',
  whatIsIncluded: 'whatIsIncluded',
  toUpdate: 'toUpdate',
  bibWithdrawalFullAddress: 'bibWithdrawalFullAddress',
  volunteerCode: 'volunteerCode',
  isAttendeeListPublic: 'isAttendeeListPublic',
  publicAttendeeListColumns: 'publicAttendeeListColumns',
  hasEditedDates: 'hasEditedDates',
  timeZone: 'timeZone',
  customerType: 'customerType',
  dataSource: 'dataSource',
  status: 'status',
  calendarStatus: 'calendarStatus',
  clientStatus: 'clientStatus',
  editionHubspotId: 'editionHubspotId',
  editionSwellId: 'editionSwellId',
  federationId: 'federationId',
  airtableId: 'airtableId',
  organizerStripeConnectedAccountId: 'organizerStripeConnectedAccountId',
  currentEditionEventId: 'currentEditionEventId',
  eventId: 'eventId',
  organizationId: 'organizationId'
};

exports.Prisma.EditionPartnerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  role: 'role',
  name: 'name',
  websiteUrl: 'websiteUrl',
  instagramUrl: 'instagramUrl',
  facebookUrl: 'facebookUrl',
  logoUrl: 'logoUrl',
  editionId: 'editionId'
};

exports.Prisma.EditionPartnerLocalizedContentScalarFieldEnum = {
  editionPartnerId: 'editionPartnerId',
  locale: 'locale',
  description: 'description'
};

exports.Prisma.EditionLocalizedContentScalarFieldEnum = {
  editionId: 'editionId',
  locale: 'locale',
  usefulInformation: 'usefulInformation',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmailConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  headerText: 'headerText',
  headerImageUrl: 'headerImageUrl',
  footerText: 'footerText',
  footerImageUrl: 'footerImageUrl',
  editionId: 'editionId',
  raceId: 'raceId',
  groupId: 'groupId',
  showBibPickupInstructions: 'showBibPickupInstructions'
};

exports.Prisma.EditionBibsAssignmentConfigurationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  burntBibs: 'burntBibs',
  releaseBibMode: 'releaseBibMode',
  editionId: 'editionId'
};

exports.Prisma.BibAssignmentRuleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  index: 'index',
  start: 'start',
  end: 'end',
  ruleType: 'ruleType',
  gender: 'gender',
  response: 'response',
  productVariantId: 'productVariantId',
  editionBibsAssignmentConfigurationId: 'editionBibsAssignmentConfigurationId',
  formKey: 'formKey'
};

exports.Prisma.EditionInfoScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  generalRulesUrl: 'generalRulesUrl',
  resultsUrl: 'resultsUrl',
  whatIsIncluded: 'whatIsIncluded',
  idCardMandatoryForWithdrawal: 'idCardMandatoryForWithdrawal',
  otherPersonCanWithdraw: 'otherPersonCanWithdraw',
  milesCheckUsed: 'milesCheckUsed',
  parkingAddress: 'parkingAddress',
  bibWithdrawalInfo: 'bibWithdrawalInfo',
  editionId: 'editionId'
};

exports.Prisma.BibWithdrawalInfoScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  startDate: 'startDate',
  startTime: 'startTime',
  endTime: 'endTime',
  bibWithdrawalStreet: 'bibWithdrawalStreet',
  bibWithdrawalPostalCode: 'bibWithdrawalPostalCode',
  bibWithdrawalCity: 'bibWithdrawalCity',
  bibWithdrawalSubdivisionNameLevel2: 'bibWithdrawalSubdivisionNameLevel2',
  bibWithdrawalSubdivisionNameLevel1: 'bibWithdrawalSubdivisionNameLevel1',
  bibWithdrawalCountry: 'bibWithdrawalCountry',
  bibWithdrawalLongitude: 'bibWithdrawalLongitude',
  bibWithdrawalLatitude: 'bibWithdrawalLatitude',
  bibWithdrawalFullAddress: 'bibWithdrawalFullAddress',
  editionInfoId: 'editionInfoId'
};

exports.Prisma.EditionServiceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  description: 'description'
};

exports.Prisma.ServiceOnEditionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  editionServiceId: 'editionServiceId',
  editionInfoId: 'editionInfoId'
};

exports.Prisma.SponsorScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  sso: 'sso',
  cta_image: 'cta_image'
};

exports.Prisma.EditionSponsorshipScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sponsorId: 'sponsorId',
  editionId: 'editionId'
};

exports.Prisma.RaceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  name: 'name',
  startDate: 'startDate',
  swimDistance: 'swimDistance',
  walkDistance: 'walkDistance',
  bikeDistance: 'bikeDistance',
  runDistance: 'runDistance',
  runDistance2: 'runDistance2',
  swimRunDistance: 'swimRunDistance',
  bikeRunDistance: 'bikeRunDistance',
  runPositiveElevation: 'runPositiveElevation',
  runNegativeElevation: 'runNegativeElevation',
  price: 'price',
  priceType: 'priceType',
  paymentCollectionType: 'paymentCollectionType',
  products: 'products',
  airtableId: 'airtableId',
  slug: 'slug',
  toUpdate: 'toUpdate',
  bikeNegativeElevation: 'bikeNegativeElevation',
  bikePositiveElevation: 'bikePositiveElevation',
  walkNegativeElevation: 'walkNegativeElevation',
  walkPositiveElevation: 'walkPositiveElevation',
  timeZone: 'timeZone',
  registrationClosingDate: 'registrationClosingDate',
  registrationOpeningDate: 'registrationOpeningDate',
  isActive: 'isActive',
  isArchived: 'isArchived',
  categoryLevel1: 'categoryLevel1',
  categoryLevel2: 'categoryLevel2',
  askAttendeeGender: 'askAttendeeGender',
  askAttendeeBirthDate: 'askAttendeeBirthDate',
  askAttendeePhoneNumber: 'askAttendeePhoneNumber',
  askAttendeeNationality: 'askAttendeeNationality',
  askAttendeePostalAddress: 'askAttendeePostalAddress',
  externalFunnelURL: 'externalFunnelURL',
  minTeamSize: 'minTeamSize',
  maxTeamSize: 'maxTeamSize',
  showClubOrAssoInput: 'showClubOrAssoInput',
  showPublicationConsentCheckbox: 'showPublicationConsentCheckbox',
  showPrice: 'showPrice',
  isWaitingList: 'isWaitingList',
  resaleEnabled: 'resaleEnabled',
  displayOrder: 'displayOrder',
  raceVariantStoreId: 'raceVariantStoreId',
  medusaProductId: 'medusaProductId',
  raceHubspotId: 'raceHubspotId',
  raceSwellId: 'raceSwellId',
  federationId: 'federationId',
  distance: 'distance',
  type: 'type',
  dataSource: 'dataSource',
  licenseNumberType: 'licenseNumberType',
  distanceCategory: 'distanceCategory',
  adultJustificativeOptions: 'adultJustificativeOptions',
  minorJustificativeOptions: 'minorJustificativeOptions',
  mainRaceEditionId: 'mainRaceEditionId',
  editionId: 'editionId',
  eventId: 'eventId',
  stockDisplayThreshold: 'stockDisplayThreshold',
  stockDisplayThresholdValue: 'stockDisplayThresholdValue'
};

exports.Prisma.RaceWaitingListConfigurationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  enabled: 'enabled',
  delay: 'delay',
  autoRelease: 'autoRelease',
  additionalFields: 'additionalFields',
  releaseOrder: 'releaseOrder',
  raceId: 'raceId'
};

exports.Prisma.RaceStageScalarFieldEnum = {
  id: 'id',
  raceId: 'raceId',
  label: 'label',
  order: 'order',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RaceChecklistItemScalarFieldEnum = {
  id: 'id',
  raceStageId: 'raceStageId',
  label: 'label',
  order: 'order',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ChecklistValidationScalarFieldEnum = {
  id: 'id',
  checklistItemId: 'checklistItemId',
  attendeeId: 'attendeeId',
  validatedBy: 'validatedBy',
  validatedAt: 'validatedAt'
};

exports.Prisma.RaceInfoScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  gpxFileUrl: 'gpxFileUrl',
  startLineAddress: 'startLineAddress',
  finishLineAddress: 'finishLineAddress',
  raceId: 'raceId'
};

exports.Prisma.RaceStationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  stationType: 'stationType',
  stationLocation: 'stationLocation'
};

exports.Prisma.StationOnRaceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  raceInfoId: 'raceInfoId',
  raceStationId: 'raceStationId'
};

exports.Prisma.RaceGearScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  description: 'description'
};

exports.Prisma.GearOnRaceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  raceInfoId: 'raceInfoId',
  raceGearId: 'raceGearId'
};

exports.Prisma.TagScalarFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.RaceTagScalarFieldEnum = {
  id: 'id',
  raceId: 'raceId',
  tagId: 'tagId'
};

exports.Prisma.RaceTagTranslationScalarFieldEnum = {
  id: 'id',
  tagId: 'tagId',
  locale: 'locale',
  tagName: 'tagName'
};

exports.Prisma.RaceCategoryScalarFieldEnum = {
  id: 'id',
  distance: 'distance',
  type: 'type',
  ranking: 'ranking'
};

exports.Prisma.RaceCategoryTranslationScalarFieldEnum = {
  id: 'id',
  raceCategoryId: 'raceCategoryId',
  locale: 'locale',
  raceDistance: 'raceDistance',
  raceType: 'raceType'
};

exports.Prisma.RaceCategoryLevel1TranslationScalarFieldEnum = {
  id: 'id',
  raceCategoryLevel1: 'raceCategoryLevel1',
  translation: 'translation',
  locale: 'locale'
};

exports.Prisma.RaceCategoryLevel2TranslationScalarFieldEnum = {
  id: 'id',
  raceCategoryLevel2: 'raceCategoryLevel2',
  translation: 'translation',
  locale: 'locale'
};

exports.Prisma.OrganizationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  hubspotEnterpriseId: 'hubspotEnterpriseId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  hubspotContactId: 'hubspotContactId'
};

exports.Prisma.CountrySubdivisionScalarFieldEnum = {
  id: 'id',
  isoCode: 'isoCode',
  displayCode: 'displayCode',
  subdivisionName: 'subdivisionName',
  subdivisionCategory: 'subdivisionCategory',
  parentSubdivision: 'parentSubdivision'
};

exports.Prisma.EventContestScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  emailParticipant: 'emailParticipant',
  marketingCheck: 'marketingCheck',
  voteVerified: 'voteVerified',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  eventId: 'eventId',
  edition: 'edition',
  type: 'type',
  eventContestEditionId: 'eventContestEditionId'
};

exports.Prisma.EventContestEditionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  start: 'start',
  end: 'end',
  year: 'year',
  content: 'content',
  bannerUrl: 'bannerUrl',
  slug: 'slug',
  raceTypes: 'raceTypes'
};

exports.Prisma.AttendeesScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  cartId: 'cartId',
  orderId: 'orderId',
  raceId: 'raceId',
  boughtAt: 'boughtAt',
  cancelledAt: 'cancelledAt',
  birthDate: 'birthDate',
  bibNumber: 'bibNumber',
  bibTeamNumber: 'bibTeamNumber',
  nationality: 'nationality',
  phoneNumber: 'phoneNumber',
  postalAddressMain: 'postalAddressMain',
  postalAddressSecondary: 'postalAddressSecondary',
  hasPaidParticipation: 'hasPaidParticipation',
  clubId: 'clubId',
  clubOrAssociation: 'clubOrAssociation',
  licenseNumber: 'licenseNumber',
  licenseType: 'licenseType',
  completedCompetitionPass: 'completedCompetitionPass',
  hideInResults: 'hideInResults',
  isRegisteredByOrganizer: 'isRegisteredByOrganizer',
  postalAddressAreaLevel1: 'postalAddressAreaLevel1',
  postalAddressAreaLevel2: 'postalAddressAreaLevel2',
  postalAddressCity: 'postalAddressCity',
  postalAddressCountry: 'postalAddressCountry',
  postalAddressZipcode: 'postalAddressZipcode',
  bibWithdrawalDate: 'bibWithdrawalDate',
  hasParentalAuthorization: 'hasParentalAuthorization',
  status: 'status',
  paymentMethod: 'paymentMethod',
  gender: 'gender',
  federationName: 'federationName',
  language: 'language',
  isOffStock: 'isOffStock',
  paymentLinkSent: 'paymentLinkSent',
  fillJustificationLaterId: 'fillJustificationLaterId',
  attendeeProfileId: 'attendeeProfileId',
  groupId: 'groupId',
  draftOrderId: 'draftOrderId',
  thirdPartyDocumentStatus: 'thirdPartyDocumentStatus'
};

exports.Prisma.BibAssignmentScalarFieldEnum = {
  id: 'id',
  bibNumber: 'bibNumber',
  bibLetter: 'bibLetter',
  editionId: 'editionId',
  attendeesId: 'attendeesId',
  bibPrefix: 'bibPrefix'
};

exports.Prisma.FillJustificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  statusUpdatedAt: 'statusUpdatedAt',
  formKey: 'formKey',
  attendeeId: 'attendeeId'
};

exports.Prisma.AttendeeProfileScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  gender: 'gender',
  birthDate: 'birthDate',
  nationality: 'nationality',
  phoneNumber: 'phoneNumber',
  postalAddressMain: 'postalAddressMain',
  postalAddressSecondary: 'postalAddressSecondary',
  postalAddressAreaLevel1: 'postalAddressAreaLevel1',
  postalAddressAreaLevel2: 'postalAddressAreaLevel2',
  postalAddressCity: 'postalAddressCity',
  postalAddressCountry: 'postalAddressCountry',
  postalAddressZipcode: 'postalAddressZipcode',
  clubOrAssociation: 'clubOrAssociation',
  clubId: 'clubId',
  licenseType: 'licenseType',
  hideInResults: 'hideInResults',
  userId: 'userId'
};

exports.Prisma.AttendeeEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  attendeeEventType: 'attendeeEventType',
  title: 'title',
  content: 'content',
  createdBy: 'createdBy',
  attendeeId: 'attendeeId'
};

exports.Prisma.AttendeeNoteScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  content: 'content',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  attendeeId: 'attendeeId'
};

exports.Prisma.WaitingListHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  event: 'event',
  resellerId: 'resellerId',
  buyerId: 'buyerId'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state',
  email_verified: 'email_verified',
  jti: 'jti'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  hashedPassword: 'hashedPassword',
  image: 'image',
  firstName: 'firstName',
  lastName: 'lastName',
  language: 'language',
  organizerRequestReason: 'organizerRequestReason',
  role: 'role'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.PermissionScalarFieldEnum = {
  id: 'id',
  resourceId: 'resourceId',
  resource: 'resource',
  isOwner: 'isOwner',
  approvedAt: 'approvedAt',
  approvedBy: 'approvedBy',
  revokedAt: 'revokedAt',
  revokedBy: 'revokedBy',
  userId: 'userId'
};

exports.Prisma.UploadedDocumentScalarFieldEnum = {
  key: 'key',
  attendeeId: 'attendeeId',
  submittedAt: 'submittedAt',
  status: 'status',
  documentType: 'documentType',
  fileType: 'fileType',
  decisionReasonComment: 'decisionReasonComment',
  decisionReasonId: 'decisionReasonId',
  fileName: 'fileName'
};

exports.Prisma.DecisionReasonScalarFieldEnum = {
  id: 'id',
  code: 'code',
  type: 'type',
  reason: 'reason'
};

exports.Prisma.RaceAgeCategoryScalarFieldEnum = {
  code: 'code',
  category: 'category',
  maxYear: 'maxYear',
  minYear: 'minYear',
  maxDate: 'maxDate',
  minDate: 'minDate',
  seasonStartsAt: 'seasonStartsAt',
  seasonEndsAt: 'seasonEndsAt',
  label: 'label',
  type: 'type'
};

exports.Prisma.AgeCategoryOnRaceScalarFieldEnum = {
  raceId: 'raceId',
  raceAgeCategoryCode: 'raceAgeCategoryCode'
};

exports.Prisma.WebhookScalarFieldEnum = {
  type: 'type',
  url: 'url',
  secret: 'secret',
  canBeSentByOrganizer: 'canBeSentByOrganizer'
};

exports.Prisma.VolunteerScalarFieldEnum = {
  id: 'id',
  firstname: 'firstname',
  lastname: 'lastname',
  code: 'code',
  eventId: 'eventId'
};

exports.Prisma.FormScalarFieldEnum = {
  title: 'title',
  description: 'description',
  type: 'type',
  variableFields: 'variableFields',
  key: 'key',
  isArchived: 'isArchived',
  editableByAttendeeUntil: 'editableByAttendeeUntil'
};

exports.Prisma.FormFunnelConfigScalarFieldEnum = {
  id: 'id',
  formKey: 'formKey',
  resource: 'resource',
  resourceId: 'resourceId',
  exclusionState: 'exclusionState',
  order: 'order',
  createdAt: 'createdAt',
  conditions: 'conditions',
  isActive: 'isActive'
};

exports.Prisma.PartnerOptionScalarFieldEnum = {
  id: 'id',
  logoUrl: 'logoUrl',
  visibility: 'visibility',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  config: 'config',
  medusaProductId: 'medusaProductId'
};

exports.Prisma.PartnerOptionRaceScalarFieldEnum = {
  partnerId: 'partnerId',
  raceId: 'raceId',
  formData: 'formData'
};

exports.Prisma.FormResponseScalarFieldEnum = {
  id: 'id',
  attendeeId: 'attendeeId',
  formKey: 'formKey',
  response: 'response',
  submittedAt: 'submittedAt'
};

exports.Prisma.FeesScalarFieldEnum = {
  amountType: 'amountType',
  amount: 'amount',
  appliedTo: 'appliedTo',
  receiver: 'receiver',
  bibOrOther: 'bibOrOther',
  productId: 'productId',
  createdAt: 'createdAt',
  id: 'id',
  resource: 'resource',
  resourceId: 'resourceId'
};

exports.Prisma.ReductionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  reductionType: 'reductionType',
  gender: 'gender',
  amountType: 'amountType',
  amount: 'amount',
  isDisabled: 'isDisabled',
  validFrom: 'validFrom',
  validUntil: 'validUntil',
  groupId: 'groupId'
};

exports.Prisma.ParticipantsExportFormatScalarFieldEnum = {
  code: 'code',
  displayName: 'displayName',
  isSpecific: 'isSpecific'
};

exports.Prisma.RaceSegmentScalarFieldEnum = {
  id: 'id',
  type: 'type',
  order: 'order',
  teamSize: 'teamSize',
  distance: 'distance',
  duration: 'duration',
  raceId: 'raceId'
};

exports.Prisma.AttendeeOnRaceSegmentScalarFieldEnum = {
  attendeeId: 'attendeeId',
  raceSegmentId: 'raceSegmentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  shareId: 'shareId',
  teamRegistrationInviteId: 'teamRegistrationInviteId'
};

exports.Prisma.TeamRegistrationScalarFieldEnum = {
  shareId: 'shareId',
  cartId: 'cartId',
  teamName: 'teamName',
  captainId: 'captainId',
  segmentSize: 'segmentSize',
  isOffStock: 'isOffStock',
  paymentStatus: 'paymentStatus',
  paymentMethod: 'paymentMethod'
};

exports.Prisma.TeamRegistrationInviteScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  token: 'token',
  teamRegistrationShareId: 'teamRegistrationShareId'
};

exports.Prisma.BibNumberAttributionStrategyScalarFieldEnum = {
  editionId: 'editionId',
  id: 'id',
  raceId: 'raceId',
  startRange: 'startRange',
  endRange: 'endRange',
  attributionStrategy: 'attributionStrategy',
  attributionStrategyResourceId: 'attributionStrategyResourceId',
  attributionStrategyResourceTitle: 'attributionStrategyResourceTitle',
  attributionStrategyResponseId: 'attributionStrategyResponseId'
};

exports.Prisma.DashboardConfigScalarFieldEnum = {
  id: 'id',
  label: 'label',
  dashboardId: 'dashboardId'
};

exports.Prisma.LicenseTypeOnRaceScalarFieldEnum = {
  id: 'id',
  raceId: 'raceId',
  licenseType: 'licenseType'
};

exports.Prisma.GroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  name: 'name',
  isActive: 'isActive',
  registrationOpeningDate: 'registrationOpeningDate',
  registrationClosingDate: 'registrationClosingDate',
  editionId: 'editionId'
};

exports.Prisma.GroupRaceScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  variantId: 'variantId',
  groupId: 'groupId',
  raceId: 'raceId'
};

exports.Prisma.UserGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  groupId: 'groupId'
};

exports.Prisma.UserEventFavoriteScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  eventId: 'eventId'
};

exports.Prisma.OptionTransmissionScalarFieldEnum = {
  id: 'id',
  attendeeId: 'attendeeId',
  orderId: 'orderId',
  productFormId: 'productFormId',
  isTransmitted: 'isTransmitted'
};

exports.Prisma.EditionMediaContentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  displayName: 'displayName',
  url: 'url',
  mimeType: 'mimeType',
  editionId: 'editionId'
};

exports.Prisma.RateScalarFieldEnum = {
  rate: 'rate',
  value: 'value',
  updatedAt: 'updatedAt'
};

exports.Prisma.CookieConsentScalarFieldEnum = {
  consentId: 'consentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  cookieData: 'cookieData'
};

exports.Prisma.ConfigScalarFieldEnum = {
  key: 'key',
  value: 'value'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.EventOrderByRelevanceFieldEnum = {
  name: 'name',
  city: 'city',
  countrySubdivisionNameLevel1: 'countrySubdivisionNameLevel1',
  countrySubdivisionDisplayCodeLevel1: 'countrySubdivisionDisplayCodeLevel1',
  countrySubdivisionNameLevel2: 'countrySubdivisionNameLevel2',
  countrySubdivisionDisplayCodeLevel2: 'countrySubdivisionDisplayCodeLevel2',
  country: 'country',
  peyceReview: 'peyceReview',
  websiteUrl: 'websiteUrl',
  facebookUrl: 'facebookUrl',
  twitterUrl: 'twitterUrl',
  instagramUrl: 'instagramUrl',
  images: 'images',
  coverImage: 'coverImage',
  airtableId: 'airtableId',
  slug: 'slug',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  fullAddress: 'fullAddress',
  eventHubspotId: 'eventHubspotId',
  eventSwellId: 'eventSwellId'
};

exports.Prisma.EventLocalizedContentOrderByRelevanceFieldEnum = {
  locale: 'locale',
  review: 'review'
};

exports.Prisma.EditionOrderByRelevanceFieldEnum = {
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  slug: 'slug',
  currency: 'currency',
  year: 'year',
  generalRulesUrl: 'generalRulesUrl',
  clientExternalUrl: 'clientExternalUrl',
  bibWithdrawalStreet: 'bibWithdrawalStreet',
  bibWithdrawalPostalCode: 'bibWithdrawalPostalCode',
  bibWithdrawalCity: 'bibWithdrawalCity',
  bibWithdrawalSubdivisionNameLevel2: 'bibWithdrawalSubdivisionNameLevel2',
  bibWithdrawalSubdivisionNameLevel1: 'bibWithdrawalSubdivisionNameLevel1',
  bibWithdrawalCountry: 'bibWithdrawalCountry',
  bibWithdrawalInfo: 'bibWithdrawalInfo',
  whatIsIncluded: 'whatIsIncluded',
  bibWithdrawalFullAddress: 'bibWithdrawalFullAddress',
  volunteerCode: 'volunteerCode',
  publicAttendeeListColumns: 'publicAttendeeListColumns',
  timeZone: 'timeZone',
  editionHubspotId: 'editionHubspotId',
  editionSwellId: 'editionSwellId',
  federationId: 'federationId',
  airtableId: 'airtableId',
  organizerStripeConnectedAccountId: 'organizerStripeConnectedAccountId'
};

exports.Prisma.EditionPartnerOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  websiteUrl: 'websiteUrl',
  instagramUrl: 'instagramUrl',
  facebookUrl: 'facebookUrl',
  logoUrl: 'logoUrl'
};

exports.Prisma.EditionPartnerLocalizedContentOrderByRelevanceFieldEnum = {
  editionPartnerId: 'editionPartnerId',
  locale: 'locale',
  description: 'description'
};

exports.Prisma.EditionLocalizedContentOrderByRelevanceFieldEnum = {
  locale: 'locale',
  usefulInformation: 'usefulInformation'
};

exports.Prisma.EmailConfigOrderByRelevanceFieldEnum = {
  id: 'id',
  headerText: 'headerText',
  headerImageUrl: 'headerImageUrl',
  footerText: 'footerText',
  footerImageUrl: 'footerImageUrl'
};

exports.Prisma.EditionBibsAssignmentConfigurationOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.BibAssignmentRuleOrderByRelevanceFieldEnum = {
  id: 'id',
  response: 'response',
  productVariantId: 'productVariantId',
  editionBibsAssignmentConfigurationId: 'editionBibsAssignmentConfigurationId',
  formKey: 'formKey'
};

exports.Prisma.EditionInfoOrderByRelevanceFieldEnum = {
  id: 'id',
  generalRulesUrl: 'generalRulesUrl',
  resultsUrl: 'resultsUrl',
  whatIsIncluded: 'whatIsIncluded',
  parkingAddress: 'parkingAddress',
  bibWithdrawalInfo: 'bibWithdrawalInfo'
};

exports.Prisma.BibWithdrawalInfoOrderByRelevanceFieldEnum = {
  id: 'id',
  startTime: 'startTime',
  endTime: 'endTime',
  bibWithdrawalStreet: 'bibWithdrawalStreet',
  bibWithdrawalPostalCode: 'bibWithdrawalPostalCode',
  bibWithdrawalCity: 'bibWithdrawalCity',
  bibWithdrawalSubdivisionNameLevel2: 'bibWithdrawalSubdivisionNameLevel2',
  bibWithdrawalSubdivisionNameLevel1: 'bibWithdrawalSubdivisionNameLevel1',
  bibWithdrawalCountry: 'bibWithdrawalCountry',
  bibWithdrawalFullAddress: 'bibWithdrawalFullAddress',
  editionInfoId: 'editionInfoId'
};

exports.Prisma.EditionServiceOrderByRelevanceFieldEnum = {
  id: 'id',
  type: 'type',
  description: 'description'
};

exports.Prisma.ServiceOnEditionOrderByRelevanceFieldEnum = {
  id: 'id',
  editionServiceId: 'editionServiceId',
  editionInfoId: 'editionInfoId'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.SponsorOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.EditionSponsorshipOrderByRelevanceFieldEnum = {
  id: 'id',
  sponsorId: 'sponsorId'
};

exports.Prisma.RaceOrderByRelevanceFieldEnum = {
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  name: 'name',
  products: 'products',
  airtableId: 'airtableId',
  slug: 'slug',
  timeZone: 'timeZone',
  categoryLevel1: 'categoryLevel1',
  categoryLevel2: 'categoryLevel2',
  externalFunnelURL: 'externalFunnelURL',
  raceVariantStoreId: 'raceVariantStoreId',
  medusaProductId: 'medusaProductId',
  raceHubspotId: 'raceHubspotId',
  raceSwellId: 'raceSwellId',
  federationId: 'federationId'
};

exports.Prisma.RaceWaitingListConfigurationOrderByRelevanceFieldEnum = {
  id: 'id',
  additionalFields: 'additionalFields'
};

exports.Prisma.RaceStageOrderByRelevanceFieldEnum = {
  id: 'id',
  label: 'label'
};

exports.Prisma.RaceChecklistItemOrderByRelevanceFieldEnum = {
  id: 'id',
  raceStageId: 'raceStageId',
  label: 'label'
};

exports.Prisma.ChecklistValidationOrderByRelevanceFieldEnum = {
  id: 'id',
  checklistItemId: 'checklistItemId',
  attendeeId: 'attendeeId',
  validatedBy: 'validatedBy'
};

exports.Prisma.RaceInfoOrderByRelevanceFieldEnum = {
  id: 'id',
  gpxFileUrl: 'gpxFileUrl',
  startLineAddress: 'startLineAddress',
  finishLineAddress: 'finishLineAddress'
};

exports.Prisma.RaceStationOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.StationOnRaceOrderByRelevanceFieldEnum = {
  id: 'id',
  raceInfoId: 'raceInfoId',
  raceStationId: 'raceStationId'
};

exports.Prisma.RaceGearOrderByRelevanceFieldEnum = {
  id: 'id',
  type: 'type',
  description: 'description'
};

exports.Prisma.GearOnRaceOrderByRelevanceFieldEnum = {
  id: 'id',
  raceInfoId: 'raceInfoId',
  raceGearId: 'raceGearId'
};

exports.Prisma.RaceTagTranslationOrderByRelevanceFieldEnum = {
  locale: 'locale',
  tagName: 'tagName'
};

exports.Prisma.RaceCategoryOrderByRelevanceFieldEnum = {
  distance: 'distance',
  type: 'type'
};

exports.Prisma.RaceCategoryTranslationOrderByRelevanceFieldEnum = {
  locale: 'locale',
  raceDistance: 'raceDistance',
  raceType: 'raceType'
};

exports.Prisma.RaceCategoryLevel1TranslationOrderByRelevanceFieldEnum = {
  raceCategoryLevel1: 'raceCategoryLevel1',
  translation: 'translation',
  locale: 'locale'
};

exports.Prisma.RaceCategoryLevel2TranslationOrderByRelevanceFieldEnum = {
  raceCategoryLevel2: 'raceCategoryLevel2',
  translation: 'translation',
  locale: 'locale'
};

exports.Prisma.OrganizationOrderByRelevanceFieldEnum = {
  name: 'name',
  hubspotEnterpriseId: 'hubspotEnterpriseId',
  hubspotContactId: 'hubspotContactId'
};

exports.Prisma.CountrySubdivisionOrderByRelevanceFieldEnum = {
  isoCode: 'isoCode',
  displayCode: 'displayCode',
  subdivisionName: 'subdivisionName',
  subdivisionCategory: 'subdivisionCategory',
  parentSubdivision: 'parentSubdivision'
};

exports.Prisma.EventContestOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  emailParticipant: 'emailParticipant',
  edition: 'edition',
  type: 'type',
  eventContestEditionId: 'eventContestEditionId'
};

exports.Prisma.EventContestEditionOrderByRelevanceFieldEnum = {
  id: 'id',
  content: 'content',
  bannerUrl: 'bannerUrl',
  slug: 'slug',
  raceTypes: 'raceTypes'
};

exports.Prisma.AttendeesOrderByRelevanceFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  cartId: 'cartId',
  orderId: 'orderId',
  bibNumber: 'bibNumber',
  bibTeamNumber: 'bibTeamNumber',
  nationality: 'nationality',
  phoneNumber: 'phoneNumber',
  postalAddressMain: 'postalAddressMain',
  postalAddressSecondary: 'postalAddressSecondary',
  clubId: 'clubId',
  clubOrAssociation: 'clubOrAssociation',
  licenseNumber: 'licenseNumber',
  licenseType: 'licenseType',
  postalAddressAreaLevel1: 'postalAddressAreaLevel1',
  postalAddressAreaLevel2: 'postalAddressAreaLevel2',
  postalAddressCity: 'postalAddressCity',
  postalAddressCountry: 'postalAddressCountry',
  postalAddressZipcode: 'postalAddressZipcode',
  language: 'language',
  fillJustificationLaterId: 'fillJustificationLaterId',
  attendeeProfileId: 'attendeeProfileId',
  draftOrderId: 'draftOrderId'
};

exports.Prisma.BibAssignmentOrderByRelevanceFieldEnum = {
  id: 'id',
  bibLetter: 'bibLetter',
  attendeesId: 'attendeesId',
  bibPrefix: 'bibPrefix'
};

exports.Prisma.FillJustificationOrderByRelevanceFieldEnum = {
  id: 'id',
  formKey: 'formKey',
  attendeeId: 'attendeeId'
};

exports.Prisma.AttendeeProfileOrderByRelevanceFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  nationality: 'nationality',
  phoneNumber: 'phoneNumber',
  postalAddressMain: 'postalAddressMain',
  postalAddressSecondary: 'postalAddressSecondary',
  postalAddressAreaLevel1: 'postalAddressAreaLevel1',
  postalAddressAreaLevel2: 'postalAddressAreaLevel2',
  postalAddressCity: 'postalAddressCity',
  postalAddressCountry: 'postalAddressCountry',
  postalAddressZipcode: 'postalAddressZipcode',
  clubOrAssociation: 'clubOrAssociation',
  clubId: 'clubId',
  licenseType: 'licenseType',
  userId: 'userId'
};

exports.Prisma.AttendeeEventOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  createdBy: 'createdBy',
  attendeeId: 'attendeeId'
};

exports.Prisma.AttendeeNoteOrderByRelevanceFieldEnum = {
  id: 'id',
  content: 'content',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  attendeeId: 'attendeeId'
};

exports.Prisma.WaitingListHistoryOrderByRelevanceFieldEnum = {
  id: 'id',
  resellerId: 'resellerId',
  buyerId: 'buyerId'
};

exports.Prisma.AccountOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state',
  jti: 'jti'
};

exports.Prisma.SessionOrderByRelevanceFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId'
};

exports.Prisma.UserOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  hashedPassword: 'hashedPassword',
  image: 'image',
  firstName: 'firstName',
  lastName: 'lastName',
  language: 'language'
};

exports.Prisma.VerificationTokenOrderByRelevanceFieldEnum = {
  identifier: 'identifier',
  token: 'token'
};

exports.Prisma.PermissionOrderByRelevanceFieldEnum = {
  id: 'id',
  approvedBy: 'approvedBy',
  revokedBy: 'revokedBy',
  userId: 'userId'
};

exports.Prisma.UploadedDocumentOrderByRelevanceFieldEnum = {
  key: 'key',
  attendeeId: 'attendeeId',
  fileType: 'fileType',
  decisionReasonComment: 'decisionReasonComment',
  fileName: 'fileName'
};

exports.Prisma.DecisionReasonOrderByRelevanceFieldEnum = {
  code: 'code',
  reason: 'reason'
};

exports.Prisma.RaceAgeCategoryOrderByRelevanceFieldEnum = {
  code: 'code',
  label: 'label'
};

exports.Prisma.AgeCategoryOnRaceOrderByRelevanceFieldEnum = {
  raceAgeCategoryCode: 'raceAgeCategoryCode'
};

exports.Prisma.WebhookOrderByRelevanceFieldEnum = {
  url: 'url',
  secret: 'secret'
};

exports.Prisma.VolunteerOrderByRelevanceFieldEnum = {
  firstname: 'firstname',
  lastname: 'lastname',
  code: 'code'
};

exports.Prisma.FormOrderByRelevanceFieldEnum = {
  title: 'title',
  description: 'description',
  key: 'key'
};

exports.Prisma.FormFunnelConfigOrderByRelevanceFieldEnum = {
  id: 'id',
  formKey: 'formKey'
};

exports.Prisma.PartnerOptionOrderByRelevanceFieldEnum = {
  id: 'id',
  logoUrl: 'logoUrl',
  medusaProductId: 'medusaProductId'
};

exports.Prisma.PartnerOptionRaceOrderByRelevanceFieldEnum = {
  partnerId: 'partnerId'
};

exports.Prisma.FormResponseOrderByRelevanceFieldEnum = {
  id: 'id',
  attendeeId: 'attendeeId',
  formKey: 'formKey'
};

exports.Prisma.FeesOrderByRelevanceFieldEnum = {
  receiver: 'receiver',
  productId: 'productId',
  id: 'id'
};

exports.Prisma.ReductionOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.ParticipantsExportFormatOrderByRelevanceFieldEnum = {
  code: 'code',
  displayName: 'displayName'
};

exports.Prisma.RaceSegmentOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.AttendeeOnRaceSegmentOrderByRelevanceFieldEnum = {
  attendeeId: 'attendeeId',
  raceSegmentId: 'raceSegmentId',
  shareId: 'shareId',
  teamRegistrationInviteId: 'teamRegistrationInviteId'
};

exports.Prisma.TeamRegistrationOrderByRelevanceFieldEnum = {
  shareId: 'shareId',
  cartId: 'cartId',
  teamName: 'teamName',
  captainId: 'captainId'
};

exports.Prisma.TeamRegistrationInviteOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  token: 'token',
  teamRegistrationShareId: 'teamRegistrationShareId'
};

exports.Prisma.BibNumberAttributionStrategyOrderByRelevanceFieldEnum = {
  attributionStrategyResourceId: 'attributionStrategyResourceId',
  attributionStrategyResourceTitle: 'attributionStrategyResourceTitle',
  attributionStrategyResponseId: 'attributionStrategyResponseId'
};

exports.Prisma.DashboardConfigOrderByRelevanceFieldEnum = {
  label: 'label'
};

exports.Prisma.GroupOrderByRelevanceFieldEnum = {
  slug: 'slug',
  name: 'name'
};

exports.Prisma.GroupRaceOrderByRelevanceFieldEnum = {
  variantId: 'variantId'
};

exports.Prisma.UserGroupOrderByRelevanceFieldEnum = {
  userId: 'userId'
};

exports.Prisma.UserEventFavoriteOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId'
};

exports.Prisma.OptionTransmissionOrderByRelevanceFieldEnum = {
  id: 'id',
  attendeeId: 'attendeeId',
  orderId: 'orderId',
  productFormId: 'productFormId'
};

exports.Prisma.EditionMediaContentOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  displayName: 'displayName',
  url: 'url',
  mimeType: 'mimeType'
};

exports.Prisma.RateOrderByRelevanceFieldEnum = {
  rate: 'rate'
};

exports.Prisma.CookieConsentOrderByRelevanceFieldEnum = {
  consentId: 'consentId'
};

exports.Prisma.ConfigOrderByRelevanceFieldEnum = {
  value: 'value'
};
exports.EventStatus = exports.$Enums.EventStatus = {
  DEAD: 'DEAD',
  DRAFT: 'DRAFT',
  REVIEW: 'REVIEW',
  LIVE: 'LIVE',
  DELETED: 'DELETED'
};

exports.DataSource = exports.$Enums.DataSource = {
  ORGANIZER: 'ORGANIZER',
  TIMER: 'TIMER',
  FEDERATION: 'FEDERATION',
  PEYCE: 'PEYCE',
  OTHER: 'OTHER'
};

exports.MedusaVersion = exports.$Enums.MedusaVersion = {
  V1: 'V1',
  V2: 'V2'
};

exports.CustomerType = exports.$Enums.CustomerType = {
  BASIC: 'BASIC',
  PREMIUM: 'PREMIUM',
  ESSENTIAL: 'ESSENTIAL',
  MEDIA: 'MEDIA',
  LEAD_INT: 'LEAD_INT',
  LEAD_EXT: 'LEAD_EXT'
};

exports.EditionStatus = exports.$Enums.EditionStatus = {
  DRAFT: 'DRAFT',
  LIVE: 'LIVE'
};

exports.CalendarStatus = exports.$Enums.CalendarStatus = {
  CONFIRMED: 'CONFIRMED',
  CANCELED: 'CANCELED',
  TO_BE_CONFIRMED: 'TO_BE_CONFIRMED'
};

exports.ClientStatus = exports.$Enums.ClientStatus = {
  EXTERNAL_SALES_FUNNEL: 'EXTERNAL_SALES_FUNNEL',
  INTERNAL_SALES_FUNNEL: 'INTERNAL_SALES_FUNNEL',
  NEW_SALES_FUNNEL: 'NEW_SALES_FUNNEL'
};

exports.EditionPartnerRole = exports.$Enums.EditionPartnerRole = {
  ORGANIZER: 'ORGANIZER',
  TIMER: 'TIMER'
};

exports.ReleaseBibMode = exports.$Enums.ReleaseBibMode = {
  BURN: 'BURN',
  RECYCLE: 'RECYCLE'
};

exports.BibAssignmentRuleType = exports.$Enums.BibAssignmentRuleType = {
  REGISTRATION_DATE: 'REGISTRATION_DATE',
  GENDER: 'GENDER',
  FORM_RESPONSE: 'FORM_RESPONSE',
  PRODUCT_VARIANT: 'PRODUCT_VARIANT'
};

exports.Gender = exports.$Enums.Gender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE'
};

exports.PriceType = exports.$Enums.PriceType = {
  PER_TEAM: 'PER_TEAM',
  PER_PERSON: 'PER_PERSON'
};

exports.PaymentCollectionType = exports.$Enums.PaymentCollectionType = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE'
};

exports.RaceDistance = exports.$Enums.RaceDistance = {
  LESS_THAN_5_KM: 'LESS_THAN_5_KM',
  KM5: 'KM5',
  KM10: 'KM10',
  KM15: 'KM15',
  KM20: 'KM20',
  HALF_MARATHON: 'HALF_MARATHON',
  MARATHON: 'MARATHON',
  EKIDEN: 'EKIDEN',
  ULTRA_RUNNING: 'ULTRA_RUNNING',
  DISCOVERY_TRAIL: 'DISCOVERY_TRAIL',
  SHORT_TRAIL: 'SHORT_TRAIL',
  LONG_TRAIL: 'LONG_TRAIL',
  ULTRA_TRAIL: 'ULTRA_TRAIL',
  VERTICAL_KILOMETER: 'VERTICAL_KILOMETER',
  SHORT_CROSS: 'SHORT_CROSS',
  LONG_CROSS: 'LONG_CROSS',
  SHORT_OBSTACLES: 'SHORT_OBSTACLES',
  LONG_OBSTACLES: 'LONG_OBSTACLES',
  NORDIC_WALK: 'NORDIC_WALK',
  HIKING: 'HIKING',
  ULTRA_CYCLING: 'ULTRA_CYCLING',
  BIKE_PACKING: 'BIKE_PACKING',
  AUDAX: 'AUDAX',
  GRAN_FONDO: 'GRAN_FONDO',
  ENDURANCE_CYCLING: 'ENDURANCE_CYCLING',
  CRITERIUM: 'CRITERIUM',
  GENTLEMAN: 'GENTLEMAN',
  RIDE: 'RIDE',
  RACE: 'RACE',
  XS: 'XS',
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL',
  XXL: 'XXL',
  TRIATHLON_KIDS: 'TRIATHLON_KIDS',
  TRIATHLON_XS: 'TRIATHLON_XS',
  TRIATHLON_S: 'TRIATHLON_S',
  TRIATHLON_M: 'TRIATHLON_M',
  TRIATHLON_L: 'TRIATHLON_L',
  TRIATHLON_XL: 'TRIATHLON_XL',
  TRIATHLON_XXL: 'TRIATHLON_XXL',
  ULTRA_TRIATHLON: 'ULTRA_TRIATHLON',
  CROSS_TRIATHLON: 'CROSS_TRIATHLON',
  DUATHLON: 'DUATHLON',
  CROSS_DUATHLON: 'CROSS_DUATHLON',
  AQUATHLON: 'AQUATHLON',
  RUN_BIKE: 'RUN_BIKE',
  SWIM_RUN: 'SWIM_RUN',
  SWIM_BIKE: 'SWIM_BIKE',
  COLOR_RUN: 'COLOR_RUN',
  OBSTACLE_RACE: 'OBSTACLE_RACE',
  MUD_RACE: 'MUD_RACE',
  SPARTAN_RACE: 'SPARTAN_RACE',
  CROSS: 'CROSS',
  NO_FINISH_LINE: 'NO_FINISH_LINE'
};

exports.RaceType = exports.$Enums.RaceType = {
  ROAD_RACE: 'ROAD_RACE',
  TRAIL: 'TRAIL',
  WALK: 'WALK',
  OBSTACLES_RACE: 'OBSTACLES_RACE',
  CROSS: 'CROSS',
  GRAVEL: 'GRAVEL',
  TRIATHLON: 'TRIATHLON',
  DUATHLON: 'DUATHLON',
  SWIM_RUN: 'SWIM_RUN',
  ROAD_BIKE: 'ROAD_BIKE',
  TRIATHLON2: 'TRIATHLON2',
  FUN_RACE: 'FUN_RACE'
};

exports.LicenseNumberType = exports.$Enums.LicenseNumberType = {
  FFA: 'FFA',
  FFTRI: 'FFTRI',
  FFS: 'FFS',
  NONE: 'NONE'
};

exports.DistanceCategoryType = exports.$Enums.DistanceCategoryType = {
  XXS: 'XXS',
  XS: 'XS',
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL',
  XXL: 'XXL'
};

exports.AdultJustificativeType = exports.$Enums.AdultJustificativeType = {
  MEDICAL_CERTIFICATE: 'MEDICAL_CERTIFICATE',
  NONE: 'NONE'
};

exports.MinorJustificativeType = exports.$Enums.MinorJustificativeType = {
  HEALTH_QUESTIONNAIRE: 'HEALTH_QUESTIONNAIRE',
  PARENTAL_AUTHORIZATION: 'PARENTAL_AUTHORIZATION',
  CHECKBOX_AUTHORIZATION: 'CHECKBOX_AUTHORIZATION',
  NONE: 'NONE'
};

exports.RaceStockDisplayThreshold = exports.$Enums.RaceStockDisplayThreshold = {
  BELOW: 'BELOW',
  ALWAYS: 'ALWAYS',
  NEVER: 'NEVER'
};

exports.WaitingListReleaseOrder = exports.$Enums.WaitingListReleaseOrder = {
  REGISTRATION_DATE: 'REGISTRATION_DATE',
  RANDOM: 'RANDOM'
};

exports.StationType = exports.$Enums.StationType = {
  SOLID: 'SOLID',
  LIQUID: 'LIQUID',
  COOLING: 'COOLING'
};

exports.StationLocation = exports.$Enums.StationLocation = {
  ON_COURSE: 'ON_COURSE',
  ARRIVAL: 'ARRIVAL'
};

exports.TagName = exports.$Enums.TagName = {
  VIRTUAL_RACE: 'VIRTUAL_RACE',
  WOMEN_ONLY: 'WOMEN_ONLY',
  KIDS_ONLY: 'KIDS_ONLY',
  FFA_DEP: 'FFA_DEP',
  FFA_REG: 'FFA_REG',
  FFA_NAT: 'FFA_NAT',
  FFA_INT: 'FFA_INT',
  NIGHT_RUN: 'NIGHT_RUN',
  FUN_RACE: 'FUN_RACE'
};

exports.AttendeeStatus = exports.$Enums.AttendeeStatus = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  PAID_MANUALLY: 'PAID_MANUALLY',
  FREE: 'FREE',
  WAITING_LIST: 'WAITING_LIST'
};

exports.PaymentMethod = exports.$Enums.PaymentMethod = {
  CREDIT_CARD: 'CREDIT_CARD',
  CHEQUE: 'CHEQUE',
  CASH: 'CASH',
  OTHER: 'OTHER'
};

exports.Federation = exports.$Enums.Federation = {
  FFA: 'FFA',
  NONE: 'NONE',
  FFTRI: 'FFTRI',
  FCD: 'FCD',
  FFSA: 'FFSA',
  FFH: 'FFH',
  FSPN: 'FSPN',
  FS_ASPTT: 'FS_ASPTT',
  FSCF: 'FSCF',
  FSGT: 'FSGT',
  UFOLEP: 'UFOLEP',
  FFC: 'FFC',
  FFVelo: 'FFVelo',
  FFVL: 'FFVL',
  FFS: 'FFS',
  FFME: 'FFME',
  FFCAM: 'FFCAM',
  FFRando: 'FFRando',
  FFHandisport: 'FFHandisport',
  FFCO: 'FFCO',
  FFST: 'FFST',
  FFN: 'FFN',
  FINA: 'FINA',
  FFESSM: 'FFESSM',
  UCI: 'UCI'
};

exports.DocumentStatus = exports.$Enums.DocumentStatus = {
  VALID: 'VALID',
  REFUSED: 'REFUSED',
  UNVERIFIED: 'UNVERIFIED',
  NOT_SENT: 'NOT_SENT'
};

exports.FillJustificationStatus = exports.$Enums.FillJustificationStatus = {
  UNSUBMITTED: 'UNSUBMITTED',
  SUBMITTED: 'SUBMITTED',
  RESUBMIT: 'RESUBMIT'
};

exports.AttendeeEventType = exports.$Enums.AttendeeEventType = {
  EMAIL_AUTO: 'EMAIL_AUTO',
  EMAIL_MANUAL: 'EMAIL_MANUAL',
  UPLOAD: 'UPLOAD',
  CONNECT: 'CONNECT',
  REGISTER: 'REGISTER',
  PAYMENT: 'PAYMENT'
};

exports.WaitingListHistoryEvent = exports.$Enums.WaitingListHistoryEvent = {
  RESALE_STARTED: 'RESALE_STARTED',
  RESALE_COMPLETED: 'RESALE_COMPLETED',
  BUYER_WAITING: 'BUYER_WAITING',
  BUYER_EXPIRED: 'BUYER_EXPIRED',
  BUYER_CONTACTED: 'BUYER_CONTACTED',
  BUYER_COMPLETED: 'BUYER_COMPLETED'
};

exports.OrganizerRequestReason = exports.$Enums.OrganizerRequestReason = {
  REGISTRATIONS: 'REGISTRATIONS',
  UPDATE_EVENTS: 'UPDATE_EVENTS',
  MISSING_EVENT: 'MISSING_EVENT',
  PLATFORM_TOUR: 'PLATFORM_TOUR',
  OTHER: 'OTHER'
};

exports.UserRole = exports.$Enums.UserRole = {
  ADMIN: 'ADMIN',
  ORGANIZER: 'ORGANIZER',
  GROUP_CONTACT: 'GROUP_CONTACT',
  VOLUNTEER: 'VOLUNTEER'
};

exports.PermissionResource = exports.$Enums.PermissionResource = {
  EVENT: 'EVENT',
  EDITION: 'EDITION',
  RACE: 'RACE',
  GROUP: 'GROUP'
};

exports.UploadedDocumentStatus = exports.$Enums.UploadedDocumentStatus = {
  VALID: 'VALID',
  INVALID: 'INVALID',
  UNVERIFIED: 'UNVERIFIED'
};

exports.UploadedDocumentType = exports.$Enums.UploadedDocumentType = {
  SUPPORTING_DOCUMENT: 'SUPPORTING_DOCUMENT',
  PARENTAL_AUTHORIZATION: 'PARENTAL_AUTHORIZATION'
};

exports.DecisionReasonType = exports.$Enums.DecisionReasonType = {
  JUSTIFICATION_DOCUMENT_DECLINED: 'JUSTIFICATION_DOCUMENT_DECLINED'
};

exports.AgeCategory = exports.$Enums.AgeCategory = {
  U7_BABY_ATHLE: 'U7_BABY_ATHLE',
  U10_EVEIL_ATHLE: 'U10_EVEIL_ATHLE',
  U12_POUSSINS: 'U12_POUSSINS',
  U14_BENJAMINS: 'U14_BENJAMINS',
  U16_MINIMES: 'U16_MINIMES',
  U18_CADETS: 'U18_CADETS',
  U20_JUNIORS: 'U20_JUNIORS',
  U23_ESPOIRS: 'U23_ESPOIRS',
  SENIORS: 'SENIORS',
  MASTERS: 'MASTERS',
  MASTER_M0: 'MASTER_M0',
  MASTER_M1: 'MASTER_M1',
  MASTER_M2: 'MASTER_M2',
  MASTER_M3: 'MASTER_M3',
  MASTER_M4: 'MASTER_M4',
  MASTER_M5: 'MASTER_M5',
  MASTER_M6: 'MASTER_M6',
  MASTER_M7: 'MASTER_M7',
  MASTER_M8: 'MASTER_M8',
  MASTER_M9: 'MASTER_M9',
  MASTER_M10: 'MASTER_M10',
  MINI_POUSSINS_TRI: 'MINI_POUSSINS_TRI',
  POUSSINS_TRI: 'POUSSINS_TRI',
  PUPILLES_TRI: 'PUPILLES_TRI',
  BENJAMINS_TRI: 'BENJAMINS_TRI',
  MINIMES_TRI: 'MINIMES_TRI',
  CADETS_TRI: 'CADETS_TRI',
  JUNIORS_TRI: 'JUNIORS_TRI',
  SENIORS_S1_TRI: 'SENIORS_S1_TRI',
  SENIORS_S2_TRI: 'SENIORS_S2_TRI',
  SENIORS_S3_TRI: 'SENIORS_S3_TRI',
  SENIORS_S4_TRI: 'SENIORS_S4_TRI',
  VETERANS_V1_TRI: 'VETERANS_V1_TRI',
  VETERANS_V2_TRI: 'VETERANS_V2_TRI',
  VETERANS_V3_TRI: 'VETERANS_V3_TRI',
  VETERANS_V4_TRI: 'VETERANS_V4_TRI',
  VETERANS_V5_TRI: 'VETERANS_V5_TRI',
  VETERANS_V6_TRI: 'VETERANS_V6_TRI',
  VETERANS_V7_TRI: 'VETERANS_V7_TRI',
  VETERANS_V8_TRI: 'VETERANS_V8_TRI',
  VETERANS_V9_TRI: 'VETERANS_V9_TRI',
  VETERANS_V10_TRI: 'VETERANS_V10_TRI',
  VETERANS_V11_TRI: 'VETERANS_V11_TRI',
  VETERANS_V12_TRI: 'VETERANS_V12_TRI'
};

exports.RaceAgeCategoryType = exports.$Enums.RaceAgeCategoryType = {
  FFA: 'FFA',
  FFTRI: 'FFTRI',
  BirthDateInterval: 'BirthDateInterval',
  AgeInterval: 'AgeInterval'
};

exports.WebhookType = exports.$Enums.WebhookType = {
  DECISION_ON_CERTIFICATE: 'DECISION_ON_CERTIFICATE',
  ORDER_CONFIRMATION: 'ORDER_CONFIRMATION',
  ORGANIZER_CONNECTION_MAGIC_LINK: 'ORGANIZER_CONNECTION_MAGIC_LINK',
  DELAYED_DOCUMENT_REMINDER: 'DELAYED_DOCUMENT_REMINDER',
  EXPORT_PARTICIPANT_LIST: 'EXPORT_PARTICIPANT_LIST',
  EXPORT_PARTICIPANT_LIST_V2: 'EXPORT_PARTICIPANT_LIST_V2',
  REGISTRATION_CONFIRMATION: 'REGISTRATION_CONFIRMATION',
  RELAY_REGISTRATION_CONFIRMATION: 'RELAY_REGISTRATION_CONFIRMATION',
  USER_SIGNUP_CONFIRMATION: 'USER_SIGNUP_CONFIRMATION',
  USER_PASSWORD_RESET: 'USER_PASSWORD_RESET',
  USER_PASSWORD_CHANGED: 'USER_PASSWORD_CHANGED',
  TEAM_MEMBER_INVITE: 'TEAM_MEMBER_INVITE',
  TEAM_CAPTAIN_CONFIRMATION: 'TEAM_CAPTAIN_CONFIRMATION',
  TEAM_CAPTAIN_CONFIRMATION_BATCH: 'TEAM_CAPTAIN_CONFIRMATION_BATCH',
  TEAM_CAPTAIN_NEW_MEMBER_REGISTRATION: 'TEAM_CAPTAIN_NEW_MEMBER_REGISTRATION',
  TEAM_CAPTAIN_TEAM_FULL: 'TEAM_CAPTAIN_TEAM_FULL',
  CONTACT_FORM: 'CONTACT_FORM',
  NEWSLETTER_SUBSCRIPTION: 'NEWSLETTER_SUBSCRIPTION',
  CONTEST_CONFIRM_VOTE: 'CONTEST_CONFIRM_VOTE',
  CONTEST_VOTE_REGISTERED: 'CONTEST_VOTE_REGISTERED',
  INVITE_GROUP_CONTACT: 'INVITE_GROUP_CONTACT',
  REMOVE_GROUP_CONTACT: 'REMOVE_GROUP_CONTACT',
  ORDER_MODIFIED: 'ORDER_MODIFIED',
  ORDER_CANCELED: 'ORDER_CANCELED',
  ORDER_REFUNDED: 'ORDER_REFUNDED',
  WAITING_LIST_PRERESERVE: 'WAITING_LIST_PRERESERVE',
  SEND_PAYMENT_LINK: 'SEND_PAYMENT_LINK',
  CUSTOMIZED_EMAIL: 'CUSTOMIZED_EMAIL',
  BOARDING_PASS: 'BOARDING_PASS',
  CONFIRM_ORGANIZER_REGISTRATION: 'CONFIRM_ORGANIZER_REGISTRATION',
  APPROVE_ORGANIZER_REGISTRATION: 'APPROVE_ORGANIZER_REGISTRATION',
  INVITE_ORGANIZER: 'INVITE_ORGANIZER',
  RESALE_STARTED_TO_RESELLER: 'RESALE_STARTED_TO_RESELLER',
  RESALE_COMPLETED_TO_RESELLER: 'RESALE_COMPLETED_TO_RESELLER',
  RESALE_CANCELED_TO_RESELLER: 'RESALE_CANCELED_TO_RESELLER'
};

exports.FormType = exports.$Enums.FormType = {
  TOGGLE: 'TOGGLE',
  CHECKBOX: 'CHECKBOX',
  RADIO: 'RADIO',
  FIELDS: 'FIELDS',
  PREDEFINED: 'PREDEFINED',
  RADIO_PRODUCT: 'RADIO_PRODUCT',
  TOGGLE_PRODUCT: 'TOGGLE_PRODUCT',
  SELECT_PRODUCT: 'SELECT_PRODUCT',
  DOUBLE_SELECT_PRODUCT: 'DOUBLE_SELECT_PRODUCT',
  ADDITIONAL_DOCUMENT: 'ADDITIONAL_DOCUMENT',
  TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS'
};

exports.FormResource = exports.$Enums.FormResource = {
  ALL: 'ALL',
  EVENT: 'EVENT',
  EDITION: 'EDITION',
  RACE: 'RACE'
};

exports.FormExclusionState = exports.$Enums.FormExclusionState = {
  EXCLUDE: 'EXCLUDE'
};

exports.FeesType = exports.$Enums.FeesType = {
  FIXED: 'FIXED',
  PERCENT: 'PERCENT'
};

exports.FeesAppliedToPersona = exports.$Enums.FeesAppliedToPersona = {
  RUNNER: 'RUNNER',
  ORGANIZER: 'ORGANIZER',
  RESELLER: 'RESELLER',
  STANDBY_RUNNER: 'STANDBY_RUNNER'
};

exports.FeesBibOrOther = exports.$Enums.FeesBibOrOther = {
  BIB: 'BIB',
  OTHER: 'OTHER'
};

exports.FeesResource = exports.$Enums.FeesResource = {
  RACE: 'RACE',
  EDITION: 'EDITION',
  EVENT: 'EVENT'
};

exports.ReductionType = exports.$Enums.ReductionType = {
  LICENSED: 'LICENSED',
  MINOR: 'MINOR',
  GENDER: 'GENDER',
  GROUP: 'GROUP',
  ALL: 'ALL'
};

exports.RaceSegmentType = exports.$Enums.RaceSegmentType = {
  RUN: 'RUN',
  BIKE: 'BIKE',
  SWIM: 'SWIM',
  WALK: 'WALK',
  OTHER: 'OTHER'
};

exports.BibsAttributionStrategy = exports.$Enums.BibsAttributionStrategy = {
  ORDER: 'ORDER',
  GENDER: 'GENDER',
  FORM: 'FORM'
};

exports.OtherLicenseNumberType = exports.$Enums.OtherLicenseNumberType = {
  FCD: 'FCD',
  FFH: 'FFH',
  FFSA: 'FFSA',
  FSPN: 'FSPN',
  FS_ASPTT: 'FS_ASPTT',
  FSCF: 'FSCF',
  FSGT: 'FSGT',
  UFOLEP: 'UFOLEP',
  FFC: 'FFC',
  FFVelo: 'FFVelo',
  FFVL: 'FFVL',
  FFS: 'FFS',
  FFME: 'FFME',
  FFCAM: 'FFCAM',
  FFRando: 'FFRando',
  FFHandisport: 'FFHandisport',
  FFCO: 'FFCO',
  FFST: 'FFST',
  FFN: 'FFN',
  FINA: 'FINA',
  FFESSM: 'FFESSM',
  UCI: 'UCI',
  FFA: 'FFA',
  FFTRI: 'FFTRI'
};

exports.ConfigKey = exports.$Enums.ConfigKey = {
  I18N_LAST_INVALIDATION_AT: 'I18N_LAST_INVALIDATION_AT',
  MEDUSA_DEFAULT_STOCK_LOCATION_ID: 'MEDUSA_DEFAULT_STOCK_LOCATION_ID',
  GEONAMES_RECOMMENDED_LOCATION_IDS: 'GEONAMES_RECOMMENDED_LOCATION_IDS'
};

exports.Prisma.ModelName = {
  Event: 'Event',
  EventLocalizedContent: 'EventLocalizedContent',
  Edition: 'Edition',
  EditionPartner: 'EditionPartner',
  EditionPartnerLocalizedContent: 'EditionPartnerLocalizedContent',
  EditionLocalizedContent: 'EditionLocalizedContent',
  EmailConfig: 'EmailConfig',
  EditionBibsAssignmentConfiguration: 'EditionBibsAssignmentConfiguration',
  BibAssignmentRule: 'BibAssignmentRule',
  EditionInfo: 'EditionInfo',
  BibWithdrawalInfo: 'BibWithdrawalInfo',
  EditionService: 'EditionService',
  ServiceOnEdition: 'ServiceOnEdition',
  Sponsor: 'Sponsor',
  EditionSponsorship: 'EditionSponsorship',
  Race: 'Race',
  RaceWaitingListConfiguration: 'RaceWaitingListConfiguration',
  RaceStage: 'RaceStage',
  RaceChecklistItem: 'RaceChecklistItem',
  ChecklistValidation: 'ChecklistValidation',
  RaceInfo: 'RaceInfo',
  RaceStation: 'RaceStation',
  StationOnRace: 'StationOnRace',
  RaceGear: 'RaceGear',
  GearOnRace: 'GearOnRace',
  Tag: 'Tag',
  RaceTag: 'RaceTag',
  RaceTagTranslation: 'RaceTagTranslation',
  RaceCategory: 'RaceCategory',
  RaceCategoryTranslation: 'RaceCategoryTranslation',
  RaceCategoryLevel1Translation: 'RaceCategoryLevel1Translation',
  RaceCategoryLevel2Translation: 'RaceCategoryLevel2Translation',
  Organization: 'Organization',
  CountrySubdivision: 'CountrySubdivision',
  EventContest: 'EventContest',
  EventContestEdition: 'EventContestEdition',
  Attendees: 'Attendees',
  BibAssignment: 'BibAssignment',
  FillJustification: 'FillJustification',
  AttendeeProfile: 'AttendeeProfile',
  AttendeeEvent: 'AttendeeEvent',
  AttendeeNote: 'AttendeeNote',
  WaitingListHistory: 'WaitingListHistory',
  Account: 'Account',
  Session: 'Session',
  User: 'User',
  VerificationToken: 'VerificationToken',
  Permission: 'Permission',
  UploadedDocument: 'UploadedDocument',
  DecisionReason: 'DecisionReason',
  RaceAgeCategory: 'RaceAgeCategory',
  AgeCategoryOnRace: 'AgeCategoryOnRace',
  Webhook: 'Webhook',
  Volunteer: 'Volunteer',
  Form: 'Form',
  FormFunnelConfig: 'FormFunnelConfig',
  PartnerOption: 'PartnerOption',
  PartnerOptionRace: 'PartnerOptionRace',
  FormResponse: 'FormResponse',
  Fees: 'Fees',
  Reduction: 'Reduction',
  ParticipantsExportFormat: 'ParticipantsExportFormat',
  RaceSegment: 'RaceSegment',
  AttendeeOnRaceSegment: 'AttendeeOnRaceSegment',
  TeamRegistration: 'TeamRegistration',
  TeamRegistrationInvite: 'TeamRegistrationInvite',
  BibNumberAttributionStrategy: 'BibNumberAttributionStrategy',
  DashboardConfig: 'DashboardConfig',
  LicenseTypeOnRace: 'LicenseTypeOnRace',
  Group: 'Group',
  GroupRace: 'GroupRace',
  UserGroup: 'UserGroup',
  UserEventFavorite: 'UserEventFavorite',
  OptionTransmission: 'OptionTransmission',
  EditionMediaContent: 'EditionMediaContent',
  Rate: 'Rate',
  CookieConsent: 'CookieConsent',
  Config: 'Config'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
